import Pattern1 from './Pattern1';
import { EBackgroundPattern } from '../model/BackgroundTheme.model';

const Patterns = {
  [EBackgroundPattern.pattern1]: Pattern1,
};

export default Patterns;
